




























import { mapGetters } from 'vuex';
import CopyStakeStats from '@/views/CopyStake/CopyStakeStats/CopyStakeStats.vue';
import CopyStakeStatsTable from '@/views/CopyStake/CopyStakeStats/CopyStakeStatsTable.vue';
import CopyStakeStatsTipsTable from '@/views/CopyStake/CopyStakeStats/CopyStakeStatsTipsTable.vue';
import VExtendedDataPicker from '@/components/VExtendedDataPicker.vue';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { defaultDates, MIN_DATE } from '@/helpers/copyStakeHelpers';
import { getStreamStats } from '@/api/CopyStake/TransactionStats';
import { TStreamerStat, TStreamerStats, DateRangeParams } from '@/api/schema';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';
import { ECopyStakeFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

type TCopyStakeStatsState = {
  MIN_DATE: string;
  isLoadingStats: boolean;
  dates: DateRangeParams;
  uniqueStreamersCount: number | string;
  copyStakeGGR: number;
  copyStakeStats: TStreamerStat[];
};

export default {
  name: 'CopyStakeStatsView',
  components: {
    CopyStakeStats,
    CopyStakeStatsTable,
    CopyStakeStatsTipsTable,
    VExtendedDataPicker
  },
  mixins: [FeatureFlagRedirectMixin],
  data(): TCopyStakeStatsState {
    return {
      MIN_DATE,
      isLoadingStats: true,
      dates: { ...defaultDates },
      uniqueStreamersCount: '-',
      copyStakeGGR: 0,
      copyStakeStats: []
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    ...mapGetters('FeatureFlags', ['isAdminVisibleFeatureFlag']),
    isShowStatsTipsTable(): boolean {
      return (
        this.$role.is([
          'account',
          'admin',
          'copystake-account',
          'copystake-admin',
          'super-admin',
          'super-admin-owner'
        ]) &&
        this.operatorId &&
        this.isAdminVisibleFeatureFlag(ECopyStakeFeatureFlag.COPY_STAKE_TIPS)
      );
    }
  },
  watch: {
    operatorId: {
      handler(): void {
        this.fetchStakeStats();
      },
      immediate: true
    },
    dates: {
      handler(): void {
        this.fetchStakeStats();
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    async fetchStakeStats(): Promise<void> {
      if (!this.operatorId) return;
      this.isLoadingStats = true;

      try {
        const { ggr, uniqueStreamersCount, data }: TStreamerStats =
          await getStreamStats(this.dates);

        const isDataValid = Array.isArray(data) && data.length;

        this.copyStakeGGR = ggr;
        this.uniqueStreamersCount = uniqueStreamersCount || 0;

        this.$set(this, 'copyStakeStats', isDataValid ? data : []);

        if (!isDataValid) {
          this.$toast.error('There is no data for the specified parameters');
        }
      } catch (e) {
        errorToastMessage(e);
      } finally {
        this.isLoadingStats = false;
      }
    }
  }
};
